import { assign, createMachine } from "xstate";
import { ISelectedSimCardType } from "./types";

interface IContext {
  selectedSimCardType?: ISelectedSimCardType;
  errorMessage?: string;
}

type IEvent =
  | { type: "SET_SIM_CARD_TYPE"; value: ISelectedSimCardType }
  | { type: "SUBMIT" };

export const selectCardTypeMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        on: {
          SET_SIM_CARD_TYPE: {
            actions: "setSimCardType",
          },
          SUBMIT: [
            {
              cond: "isSimSelected",
              actions: "redirectToChangeSimNewSimPage",
              target: "goToNextStep",
            },
            {
              cond: "isEsimSelected",
              actions: "redirectToChangeSimEsimPage",
              target: "goToNextStep",
            },
            {
              actions: "setErrorMessage",
            },
          ],
        },
      },
      goToNextStep: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setSimCardType: assign((context, event: IEvent) => {
        if (event.type === "SET_SIM_CARD_TYPE") {
          return {
            selectedSimCardType: event.value,
            errorMessage: undefined,
          };
        }

        return context;
      }),
      setErrorMessage: assign((_, __: IEvent) => {
        return {
          errorMessage: "Aby przejść dalej, wybierz co chcesz zrobić.",
        };
      }),
    },
    guards: {
      isSimSelected: ({ selectedSimCardType }) => {
        return selectedSimCardType === "SIM";
      },
      isEsimSelected: ({ selectedSimCardType }) => {
        return selectedSimCardType === "eSIM";
      },
    },
  },
);
